/**
 * ROLE-BASED PERMISSIONS CONFIG
 * ─────────────────────────────────────────────────────────────
 * Single source of truth for all UI-level permissions.
 *
 * Roles:
 *   school-admin  → full access
 *   principal     → most access, no import history
 *   assistant     → limited (no teacher mgmt, no settings)
 *   accounts      → financial/settings only
 *   viewer        → read-only
 *
 * To add a new permission:
 *   1. Add a key below under PERMISSIONS
 *   2. List which roles can access it
 *   3. Use <RoleGuard permission="your_key"> or usePermission("your_key")
 * ─────────────────────────────────────────────────────────────
 */

export const PERMISSIONS = {
  // ── Dashboard ────────────────────────────────────────────────
  dashboard_add_teacher: ["school-admin", "principal", "head-master"],
  dashboard_add_student: ["school-admin", "principal", "head-master"],
  dashboard_passing_percentage: ["school-admin", "principal", "head-master"],
  dashboard_quiz_attempts: ["school-admin", "principal", "head-master"],
  dashboard_assign_licenses: ["school-admin", "principal", "head-master", "teacher"],
  dashboard_assign_teachers: ["school-admin", "principal", "head-master"],

  //classroom
  dashboard_create_classroom: ["school-admin", "principal", "head-master", "teacher"],
  dashboard_edit_classroom: ["school-admin", "principal", "head-master", "teacher"],
  dashboard_delete_classroom: ["school-admin", "principal", "head-master", "teacher"],
  dashboard_edit_delete_classroom: ["school-admin", "principal", "head-master", "teacher"],
  dashboard_classroom_report: ["school-admin", "principal", "head-master", "viewer", "teacher"],

  // ── Students ─────────────────────────────────────────────────
  students_create: ["school-admin", "principal", "head-master"],
  students_edit: ["school-admin", "principal", "head-master"],
  students_delete: ["school-admin", "principal"],
  students_action: ["school-admin", "principal"],

  // ── Teachers ─────────────────────────────────────────────────
  teachers_create: ["school-admin", "principal", "head-master"],
  teachers_edit: ["school-admin", "principal", "head-master"],
  teachers_delete: ["school-admin", "principal", "head-master"],
  teachers_edit_delete: ["school-admin", "principal", "head-master"],
  teachers_classrooms: ["school-admin", "principal", "head-master"],

  // ── Reports ──────────────────────────────────────────────────
  reports_view: ["school-admin", "principal", "head-master"],
  reports_export: ["school-admin", "principal", "head-master"],

  // ── Settings ─────────────────────────────────────────────────
  settings_profile: ["organization-admin", "school-admin", "principal", "accounts", "head-master"],
  settings_view: ["organization-admin", "school-admin", "principal", "accounts", "head-master"],
  settings_edit: ["school-admin", "principal", "head-master", "organization-admin"],
  settings_school_session: ["school-admin", "principal", "organization-admin"],
  settings_school_members: ["school-admin"],
  settings_school_payments: ["school-admin", "accounts", "principal", "organization-admin"],
  settings_school_invoices: ["school-admin", "accounts", "principal", "organization-admin"],
  settings_school_licenses: ["school-admin", "accounts", "principal", "organization-admin"],

  // ── Import History ───────────────────────────────────────────
  import_history_view: ["school-admin", "principal", "head-master"],
};
